<template>
  <div style="position: relative">
    <div dir="rtl" class="page">
      <div dir="ltr">
        <h4>使用教程</h4>
        <a v-for="item in list" :href="item.Url" target="_blank" class="item">
          
          <div class="img-box">
            <img class="video_img" :src="item.CoverUrl">
            <span class="time">{{item.Duration}}</span>
            <img v-if="item.CoverUrl" class="teach" src="../assets/image/video_teach_ico.png">
          </div>
          <p class="videotitle"><strong>{{item.Title}}</strong></p>
          <p class="videodesc">{{item.Describe}}</p>
        </a>
      </div>
    </div>
    <!--<div class="div-bottom">-->
      <!--<button class="btn btn-bottom" onclick="window.open('https://monitor.5118.com/keywords')">查看更多官方使用教程</button>-->
    <!--</div>-->
  </div>
</template>

<script>
  import {mapActions} from "vuex"

  export default {
    name: "Vedio",
    mounted() {
      this.ASetHistory("vedio").then(flag => {
        if(flag){
          this.$messenger.addTarget(window.parent, 'parent');
          this.$messenger.targets['parent'].send("5118_vidoe_sendmessage");
          this.listen();
        }
      });
    },
    computed: {
      list: {
        get() {
          return this.$store.state.vedio.list
        },
        set(val) {
          this.$store.state.vedio.list = val
        }
      }
    },
    methods: {
      ...mapActions("menu", ["ASetHistory"]),
      listen(){
        this.$messenger.listen("_5118_Video_List", (msg) => {
          this.list=msg;
        });
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .item {
    display: block;
    margin-top: 10px;
  }

  .img-box {
    display: block;
    position: relative;
    .video_img {
      width: 100%;
      border-radius: 2px;
    }
    .time {
      color: #fff;
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 12px;
    }.teach{
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
  .videodesc{
    color:#999;
    font-size: 12px;
    line-height: 20px;
    margin-top: 5px;
    letter-spacing: 1px;
  }
  .videotitle{
    font-size: 12px;
    margin-top: 10px;
  }

  .page {
    padding: 12px;
    height: calc(100%);
    overflow: auto;
  }
</style>
<style type="text/less" lang="less">
  .message-item {
    img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Vedio.vue